import * as s from "@gromia/components/theme/t.module.css";
import { Circles } from "@gromia/components/ui/Circles";
import { Text } from "@gromia/components/ui/Text";
import strings from "@gromia/strings/landingSell";
import { useString } from "@gromia/utils/useString";
import cx from "classnames";
import * as React from "react";
import { ExampleListingCard } from "./ExampleListingCard";

export function Marketing() {
  const { tx } = useString("landingSell", strings);

  return (
    <section className={cx(s.bgPrimaryDarker, s.spaceTop2, s.textCenter)}>
      <div className={s.container}>
        <Text tag="p" s="pill" inverted>
          {tx("marketingPill")}
        </Text>
        <Text tag="h2" s="title" inverted>
          {tx("marketingTitle")}
        </Text>
        <Text tag="p" s="p" inverted>
          {tx("marketingText")}
        </Text>
      </div>
      <div className={cx(s.spaceTop3, s.spaceTopLg2)} />
      <Circles radius={450} count={3} cliph={0.4}>
        <ExampleListingCard
          pill={tx("cardPill")}
          customerName={tx("cardCustomer")}
          price={tx("cardPrice")}
          title={tx("cardTitle")}
          subtitle={tx("cardSubtitle")}
        />
      </Circles>
    </section>
  );
}
